/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theeventhasbeenmarkedascanceled6Inputs */

const en_theeventhasbeenmarkedascanceled6 = /** @type {(inputs: Theeventhasbeenmarkedascanceled6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event has been marked as canceled.`)
};

const de_theeventhasbeenmarkedascanceled6 = /** @type {(inputs: Theeventhasbeenmarkedascanceled6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wurde als abgesagt markiert.`)
};

/**
* | output |
* | --- |
* | "The event has been marked as canceled." |
*
* @param {Theeventhasbeenmarkedascanceled6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const theeventhasbeenmarkedascanceled6 = /** @type {((inputs?: Theeventhasbeenmarkedascanceled6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theeventhasbeenmarkedascanceled6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theeventhasbeenmarkedascanceled6(inputs)
	return de_theeventhasbeenmarkedascanceled6(inputs)
});
export { theeventhasbeenmarkedascanceled6 as "theEventHasBeenMarkedAsCanceled" }